import React from 'react';
import styles from './index.module.css';
import Popup from '../../components/Popup';
import {
  formatDatetimeToString,
  isPreferenceConfirmRegistrationVersion
} from '../../utils';
import classNames from 'classnames';
import { path } from 'ramda';
import moment from 'moment';
import 'moment/locale/ja';
import heldFridayParticipation from '@assets/Participation/held_friday_participation.png';
import cancelWaitlistParticipation from '@assets/Participation/cancel_waitlist_participation.png';
import heriDatingContent from '@assets/Participation/heri_dating_content.png';
import dailyDatingPopupTitleDecor1 from '@assets/Participation/daily_dating_popup_title_decoration.png';
import dailyDatingPopupTitleDecor2 from '@assets/Participation/daily_dating_popup_title_decoration_2.png';
import dailyDatingPopupMessageImg from '@assets/Participation/daily_dating_popup_message_img.png';
import EveryDayDating from '@assets/Participation/every_day_dating.png';
import blackUserWelcomePopupTitle from '@assets/Participation/black_user_welcome.png';
import bachelorMember from '@assets/Participation/bachelor_member.png';
import { NEW_TERM_OF_SERVICE_LINK, UserGender } from '@constants/constant';
import summerCampaignPopupBanner from '@assets/Participation/summer_campaign_banner.png';
import ikebukuroBanner from '@assets/Participation/ikebukuro_banner.png';
import yokohamaBanner from '@assets/Participation/yokohama_banner.png';
import DialogWithPhoto from '@components/Popups/DialogWithPhoto';
import Checkbox from '@components/Participation/Checkbox';
import closeWhiteMode from '@assets/common/close-white-mode.png';

export const CheckBox = (props) => {
  return props.label ? (
    <label className={styles.labelCheckBox}>
      <input
        className={styles.checkBox}
        onClick={props.onClick}
        type="checkbox"
        checked={props.checked}
      />
      {props.label}
    </label>
  ) : (
    <input
      className={styles.checkBox}
      onClick={props.onClick}
      type="checkbox"
      defaultValue={false}
      checked={props.checked}
    />
  );
};

export const updateFooterLinearWidth = () => {
  setTimeout(() => {
    const dataContent = document.querySelector(`.${styles.dataContent}`);
    if (dataContent) {
      const footerLinear = document.querySelector(`.${styles.footerLinear}`);
      if (footerLinear && dataContent.clientWidth < dataContent.offsetWidth) {
        footerLinear.style.width = `${dataContent.clientWidth}px`;
      }
    }
  }, 0);
};

export const renderWhatTimePopup = (state, closePopup) => {
  let messages = [
    '開始時間はデート前日に決定します',
    'デートは1時間程の想定です。'
  ];
  return (
    <Popup
      // key="confirmation-popup"
      visible={state.whatTimePopupVisible}
      title={'デート開始時間'}
      titleClassName={styles.titleClassName}
      messages={messages}
      messageClassName={styles.messageClassName}
      messagesContainerClassName={styles.confirmationPopupMessagesContainer}
      okButtonTitle={'了解'}
      onCancelClicked={closePopup}
      onOkClicked={closePopup}
      footerClassName={styles.confirmationPopupFooter}
    />
  );
};

export const renderWhatChangeDatingPopup = (state, closePopup, isFemale) => {
  return (
    <Popup
      visible={state.whatChangeDatingPopup}
      title={'よくある質問'}
      titleClassName={styles.titleClassName}
      MessagesComponent={
        <div className={styles.whatChangeDatingPopupMessageContainer}>
          <div className={styles.textBold}>
            {'Q.デート日の変更はできますか？'}
          </div>
          <div className={styles.subTitle}>
            {' A.デート前日昼14時までは無料で変更が可能です。'}
          </div>
          <div className={styles.textBold}>{'Q.デート場所はどこですか？'}</div>
          <div>
            {isFemale()
              ? 'A.希望された駅を元にカフェが指定されます。'
              : 'A.後ほど選択できる希望エリアをもとにカフェが指定されます。'}
          </div>
        </div>
      }
      messageClassName={styles.messageClassName}
      messagesContainerClassName={styles.confirmationPopupMessagesContainer}
      okButtonTitle={'了解'}
      onCancelClicked={closePopup}
      onOkClicked={closePopup}
      notShowCloseButton={true}
      footerClassName={styles.confirmationPopupFooter}
    />
  );
};

export const renderWaitlistNotificationPopup = (state, closePopup, date) => {
  return (
    <Popup
      visible={state.waitlistNotificationPopup}
      title={`予約枠が空いたら\nお知らせします！`}
      titleClassName={classNames({
        [styles.titleClassName]: true,
        [styles.textBold]: true
      })}
      MessagesComponent={
        <div className={styles.waitlistNotificationPopupMessageContainer}>
          <div className={styles.textBold}>{'デート日：'}</div>
          {date}
          <div className={styles.messageWaitlistNotification}>
            {'枠が空いたら順次お知らせしますので、\n今しばらくお待ちください。'}
          </div>
        </div>
      }
      messageClassName={styles.messageClassName}
      messagesContainerClassName={styles.confirmationPopupMessagesContainer}
      okButtonTitle={'了解'}
      onCancelClicked={closePopup}
      onOkClicked={closePopup}
      notShowCloseButton={true}
      footerClassName={styles.confirmationPopupFooter}
    />
  );
};

export const renderRequestAwaitingCancelCompletePopup = (state, closePopup) => {
  return (
    <Popup
      visible={state.configurationCompletePopup}
      title={'設定が完了しました！'}
      MessagesComponent={
        <div className={styles.whatChangeDatingPopupMessageContainer}>
          <div>
            予約枠が空いたら順次お知らせしますので、今しばらくお待ちください。
          </div>
          <div className={styles.textMessagePopup}>
            *受信後にお客様ご自身で予約が必要です。
          </div>
          <div className={styles.textMessagePopup}>
            *状況によっては、受信してもすぐに枠が埋まり参加できない場合がございます。
          </div>
        </div>
      }
      messageClassName={styles.messageClassName}
      messagesContainerClassName={styles.confirmationPopupMessagesContainer}
      okButtonTitle={'了解'}
      onCancelClicked={closePopup}
      onOkClicked={closePopup}
      notShowCloseButton={true}
      footerClassName={styles.confirmationPopupFooter}
    />
  );
};

export const renderCompleteValueOptionPopup = (state, closePopup) => {
  const messages = ['是非次回のデートをお楽しみください！'];
  return (
    <Popup
      // key="confirmation-popup"
      visible={state.showCompleteValueOptionPopup}
      title={'価値観の登録が完了しました'}
      titleClassName={styles.titleClassName}
      messages={messages}
      messageClassName={styles.messageClassName}
      messagesContainerClassName={styles.confirmationPopupMessagesContainer}
      okButtonTitle={'了解'}
      notShowCloseButton={true}
      onCancelClicked={closePopup}
      onOkClicked={closePopup}
      footerClassName={styles.confirmationPopupFooter}
    />
  );
};

export const renderErrorValidationPopup = (props, state, onOkeClick) => {
  const { t } = props;
  const { showValidationPopup, messageValidation } = state;

  return (
    <Popup
      visible={showValidationPopup}
      disableClose
      title={messageValidation}
      okButtonTitle={t('ok-button')}
      onOkClicked={onOkeClick}
    />
  );
};

export const renderValidateRegistrationStep = (state, onOkeClick) => {
  return (
    <Popup
      // key="confirmation-popup"
      visible={state.showValidateRegistrationPopup}
      title={state.messageValidateRegistrationStep}
      titleClassName={styles.titleClassName}
      messages={['登録フォームを入力し、審査に進みましょう！']}
      messageClassName={styles.messageClassName}
      messagesContainerClassName={styles.confirmationPopupMessagesContainer}
      okButtonTitle={'入力に進む'}
      disableClose
      onOkClicked={onOkeClick}
      footerClassName={styles.confirmationPopupFooter}
    />
  );
};

export const renderClosedDateButton = (state, date, onClick) => {
  return (
    <div
      key={date.id}
      className={classNames({
        [styles.dateButtonContainer]: true,
        [styles.dateButtonContainerClosed]: true
      })}
    >
      <div
        className={classNames({
          [styles.dateButton]: true,
          [styles.dateButtonClosed]: true,
          [styles.dateButtonClosedWhiteMode]: state.isWhiteMode
        })}
        onClick={() => onClick(date)}
      >
        {formatDatetimeToString(date.dating_date, 'YYYY-MM-DD', 'MM/DD(ddd)')}
      </div>
    </div>
  );
};

export const renderReservationCancelledConfirmationVisible = (
  props,
  state,
  isFemale,
  onOkeClick
) => {
  const { t } = props;
  const { registrationComplete } = state;

  const calcTtile = () => {
    if (isFemale()) {
      return registrationComplete
        ? t('cancel-complete-title-for-female')
        : t('cancel-complete-title-for-female-2');
    }
    return t('cancel-complete-title');
  };

  return (
    <Popup
      key="reservation-cancelled-confirm-popup"
      visible={state.reservationCancelledConfirmationVisible}
      title={calcTtile()}
      titleClassName={styles.titleClassName}
      MessagesComponent={
        <>
          <div style={{ marginTop: 36, textAlign: 'center' }}>
            {isFemale()
              ? '新しい日程を追加しましょう!'
              : '新しいデート日を予約しましょう!'}
          </div>
        </>
      }
      messageClassName={styles.messageClassName}
      okButtonTitle={t('ok-button')}
      disableClose
      onOkClicked={onOkeClick}
    />
  );
};

export const renderAwaitingCancelledDatePopup = (
  state,
  onCancelClick,
  onOkCLick
) => {
  // If this gets anymore complex, we should abstract this popup into an individual component
  const messages = ['他の会員がキャンセルした場合に予約できるようになります。'];

  return (
    <Popup
      // key="confirmation-popup"
      visible={state.awaitingCancelledDatePopupVisible}
      title={'多くの方にご参加頂いております'}
      titleClassName={styles.titleClassName}
      messages={messages}
      messageClassName={styles.messageClassName}
      messagesContainerClassName={styles.confirmationPopupMessagesContainer}
      okButtonTitle={'了解'}
      notShowCloseButton={true}
      onCancelClicked={onCancelClick}
      onOkClicked={onOkCLick}
      footerClassName={styles.confirmationPopupFooter}
    />
  );
};

export const renderConfirmUseTicketPopup = (
  state,
  onCancelClick,
  onOkClick
) => {
  const weekText = state.thisWeekSelected
    ? '今週'
    : state.nextWeekSelected
    ? '来週'
    : '再来週';
  return (
    <Popup
      visible={state.confirmUseTicketPopupVisible}
      title={'デートチケットを使いますか?'}
      titleClassName={styles.titleClassName}
      messages={[
        `${weekText}のデートを追加で予約する場合、デートチケット1枚が必要です。`
      ]}
      messageClassName={styles.messageClassName}
      messagesContainerClassName={styles.confirmationPopupMessagesContainer}
      okButtonTitle={'デートチケットを使う'}
      onCancelClicked={onCancelClick}
      onOkClicked={onOkClick}
      footerClassName={styles.confirmationPopupFooter}
    />
  );
};

export const renderClosedDatePopup = (state, onCLick) => {
  // If this gets anymore complex, we should abstract this popup into an individual component
  const date = state.currentDateDataSelected;

  const messages = date
    ? [
        `${moment(date.available_after)
          .locale('ja')
          .format('M月DD日(ddd)')} 以降に予約できるようになります。`
      ]
    : [];

  return (
    <Popup
      // key="confirmation-popup"
      visible={state.closedDatePopupVisible}
      title={'まだ予約できません'}
      titleClassName={styles.titleClassName}
      messages={messages}
      messageClassName={styles.messageClassName}
      messagesContainerClassName={styles.confirmationPopupMessagesContainer}
      okButtonTitle={'了解'}
      notShowCloseButton={true}
      onCancelClicked={onCLick}
      onOkClicked={onCLick}
      footerClassName={styles.confirmationPopupFooter}
    />
  );
};

//Trial, Awaiting for approval Or Awaiting for re-approval in case dating coupon = 0
export const renderTrialAwaitingForApprovalPopup = (state, onClick) => {
  const messages = ['初回デート参加後より複数予約ができるようになります。'];
  return (
    <Popup
      visible={state.trialAwaitingForApprovalPopupVisible}
      title={'１デートのみ予約できます'}
      titleClassName={styles.titleClassName}
      messages={messages}
      messageClassName={styles.messageClassName}
      messagesContainerClassName={styles.confirmationPopupMessagesContainer}
      okButtonTitle={'了解'}
      onCancelClicked={onClick}
      onOkClicked={onClick}
      footerClassName={styles.confirmationPopupFooter}
    />
  );
};

// マッチング中の予約キャンセル不可ポップアップ
export const renderMatchingPopup = (state, onClick) => {
  const messages = [
    'デート前日14時を過ぎたため、デートをキャンセルできません。\n16時ごろにお相手が公開されますので、楽しみにお待ちください。'
  ];
  return (
    <Popup
      visible={state.matchingPopupVisible}
      title={'デートをキャンセルできません'}
      titleClassName={styles.titleClassName}
      messages={messages}
      messageClassName={styles.messageClassName}
      messagesContainerClassName={styles.confirmationPopupMessagesContainer}
      okButtonTitle={'了解'}
      onCancelClicked={onClick}
      onOkClicked={onClick}
      footerClassName={styles.confirmationPopupFooter}
    />
  );
};

// Confirm the last time before using dating coupon
export const renderUseDatingCouponWarningPopup = (state, onClick) => {
  const messages = ['チケットを一度反映すると、取消はできません。'];

  return (
    <Popup
      visible={state.useCouponWarningPopupVisible}
      title={'ご注意ください?'}
      titleClassName={styles.titleClassName}
      messages={messages}
      messageClassName={styles.messageClassName}
      messagesContainerClassName={styles.confirmationPopupMessagesContainer}
      positiveButtonTitle={'了承して使う'}
      negativeButtonTitle={'戻る'}
      onCancelClicked={onClick}
      onNegativeClicked={onClick}
      onPositiveClicked={onClick}
      footerClassName={styles.confirmationPopupFooter}
    />
  );
};

// male user deactivated and has no succeeded date
export const renderResumptionNoSucceedDatePopup = (
  props,
  state,
  onCancelClick,
  onOkClick
) => {
  const { t } = props;
  return (
    <Popup
      visible={state.showResumptionNoSucceedDatePopup}
      title={t('deactivated-popup-title')}
      titleClassName={styles.titleClassName}
      messages={[
        t('male-deactivated-popup-message-1'),
        t('male-deactivated-popup-no-date-message')
      ]}
      messageClassName={classNames(styles.messageClassName)}
      messagesContainerClassName={styles.confirmationPopupMessagesContainer}
      contentClassName={styles.contentClassName}
      okButtonTitle={t('male-deactivated-popup-button-title')}
      onCancelClicked={onCancelClick}
      onOkClicked={onOkClick}
      footerClassName={styles.confirmationPopupFooter}
    />
  );
};

// male user deactivated and has succeeded date
export const renderResumptionSucceedDatePopup = (
  props,
  state,
  onCancelClick,
  onOkCLick
) => {
  const { t } = props;
  return (
    <Popup
      visible={state.showResumptionSucceedDatePopup}
      title={t('deactivated-popup-title')}
      titleClassName={styles.titleClassName}
      messages={[
        t('male-deactivated-popup-message-1'),
        t('male-deactivated-popup-has-date-message')
      ]}
      messageClassName={styles.messageClassName}
      messagesContainerClassName={styles.confirmationPopupMessagesContainer}
      contentClassName={styles.contentClassName}
      okButtonTitle={t('male-deactivated-popup-button-title')}
      onCancelClicked={onCancelClick}
      onOkClicked={onOkCLick}
      footerClassName={styles.confirmationPopupFooter}
    />
  );
};

// female user deactivated
export const renderResumptionPopup = (
  props,
  state,
  onCancelClick,
  onOkClick
) => {
  const { t } = props;
  return (
    <Popup
      visible={state.showResumptionPopup}
      title={t('deactivated-popup-title')}
      titleClassName={styles.titleClassName}
      messages={[t('female-deactivated-popup-message')]}
      okButtonTitle={t('female-deactivated-popup-button-title')}
      messageClassName={styles.messageClassName}
      messagesContainerClassName={styles.confirmationPopupMessagesContainer}
      contentClassName={styles.contentClassName}
      onOkClicked={onOkClick}
      onCancelClicked={onCancelClick}
      footerClassName={styles.confirmationPopupFooter}
    />
  );
};

export const renderResumptionCompletePopup = (
  state,
  onCancelClick,
  onOkCLick
) => {
  return (
    <Popup
      visible={state.showResumptionCompletePopup}
      title={'再開が完了しました'}
      titleClassName={styles.titleClassName}
      messages={['再開が完了しました。デートをお楽しみください。']}
      messageClassName={styles.messageClassName}
      messagesContainerClassName={styles.confirmationPopupMessagesContainer}
      contentClassName={styles.contentClassName}
      okButtonTitle={'デートを予約する'}
      onCancelClicked={onCancelClick}
      disableClose={true}
      onOkClicked={onOkCLick}
      footerClassName={styles.confirmationPopupFooter}
    />
  );
};

// deactivated with un-collective invoice
export const renderUnpaidPaymentPopup = (props, state, onOkCLick) => {
  const { t } = props;
  return (
    <Popup
      visible={state.unpaid_payment_popup}
      title={t('unpaid-payment-popup-title')}
      titleClassName={styles.titleClassName}
      messages={[t('unpaid-payment-popup-message')]}
      okButtonTitle={t('unpaid-payment-popup-button-title')}
      messageStyle={{ textAlign: 'left' }}
      messageClassName={styles.messageClassName}
      messagesContainerClassName={styles.confirmationPopupMessagesContainer}
      contentClassName={styles.contentClassName}
      disableClose={true}
      onOkClicked={onOkCLick}
      footerClassName={styles.confirmationPopupFooter}
    />
  );
};

//Need to click when users have participation
export const renderInvalidCancelChangePopup = (props, state, onOkCLick) => {
  const { t } = props;
  return (
    <Popup
      visible={state.invalidCancelChangePopup}
      title={'日程をタップしてください'}
      titleClassName={styles.titleClassName}
      messages={[
        '変更/キャンセルする場合は、予約済みのデート日を選択してください。\n'
      ]}
      okButtonTitle={t('ok-button')}
      messageStyle={{ textAlign: 'left' }}
      messageClassName={styles.messageClassName}
      messagesContainerClassName={styles.confirmationPopupMessagesContainer}
      contentClassName={styles.contentClassName}
      disableClose={true}
      onOkClicked={onOkCLick}
      footerClassName={styles.confirmationPopupFooter}
    />
  );
};

export const renderValidateSelectDateFailPopup = (state, onOkCLick) => {
  const title = '';
  const message = [state.validateSelectDateFailContent] || [];
  const positiveBtn = 'ログアウト';
  return (
    <Popup
      visible={state.validateSelectDateFailPopup}
      title={title}
      titleClassName={styles.titleClassName}
      messages={message}
      messageClassName={styles.validateErrorMessage}
      okButtonTitle={positiveBtn}
      onOkClicked={onOkCLick}
      disableClose={true}
    />
  );
};
export const renderPaymentNotCompletedPopup = (
  state,
  onOkCLick,
  onCancelClick
) => {
  const message = [
    'お支払いが完了していないため、現在ご利用できません。',
    'お支払いが完了すると、ご利用いただけます。'
  ];
  return (
    <Popup
      visible={state.paymentNotCompletedPopup}
      title="お支払いが完了しておりません"
      titleClassName={styles.titleClassName}
      messages={message}
      messageClassName={styles.messageClassName}
      okButtonTitle="お支払い確認ページへ"
      onOkClicked={onOkCLick}
      onCancelClicked={onCancelClick}
    />
  );
};

export const renderRefundCommitOptionPopup = (
  state,
  onCancelClick,
  onPositiveClick,
  onNegativeClick
) => {
  return (
    <Popup
      visible={state.refundCommitOptionPopupVisible}
      title={'本当に返金申請をしますか？'}
      titleClassName={styles.titleClassName}
      messages={[
        '返金申請をすると、6/30(木)までに交際できた場合にお祝い金(最大5万円)がお渡しできません。'
      ]}
      messageClassName={styles.messageClassName}
      onCancelClicked={onCancelClick}
      positiveButtonTitle={'返金申請する'}
      positiveButtonClassName={styles.positiveButtonClassName}
      negativeButtonTitle={'返金申請する'}
      negativeButtonClassName={styles.negativeButtonClassName}
      onPositiveClicked={onPositiveClick}
      onNegativeClicked={onNegativeClick}
      footerClassName={styles.cancelReservationFooter}
    />
  );
};

export const renderParticipationTwoDatingPopup = (
  state,
  onCancelClick,
  onPositiveClick,
  onNegativeClick
) => {
  return (
    <Popup
      visible={state.showParticipationTwoDatingPopup}
      title={'このままお相手を探しますか？'}
      titleClassName={styles.titleClassName}
      messages={[
        '空いてる日程を多く選択すると、理想のお相手が見つかりやすくなります。'
      ]}
      messageClassName={styles.messageClassName}
      onCancelClicked={onCancelClick}
      positiveButtonTitle={'空いてる日程を追加する'}
      positiveButtonClassName={styles.positiveButtonClassName}
      negativeButtonTitle={'このままお相手を探す'}
      negativeButtonClassName={styles.negativeButtonClassName}
      onPositiveClicked={onPositiveClick}
      onNegativeClicked={onNegativeClick}
      disableClose
    />
  );
};

export const renderHoldFridayDatingPopup = (state, onPositiveClick) => {
  return (
    <Popup
      visible={state.showHeldFridayDatingPopup}
      title={'金曜デートが解禁!'}
      contentStyle={styles.heldFridayContentPopup}
      titleClassName={classNames(styles.titleClassName, styles.bigPopupTitle)}
      messages={[
        '金曜夜もデートをしたい',
        'という多くのユーザー様のご意見を元に',
        '金曜デートを開催しました。'
      ]}
      messagesContainerClassName={styles.imageContentMsg}
      boldMsgIndex={[0]}
      imageUnderTitle={heldFridayParticipation}
      textCenterMsg={true}
      messageClassName={classNames(styles.messageClassName, styles.centerMsg)}
      positiveButtonTitle={'了解'}
      positiveButtonClassName={styles.positiveButtonClassName}
      onPositiveClicked={onPositiveClick}
      disableClose
    />
  );
};

export const renderCancelWaitlistPopup = (
  state,
  onPositiveClick,
  date,
  onClose
) => {
  return (
    <Popup
      visible={state.cancelWaitlistPopup}
      title={'キャンセル待ち設定'}
      contentStyle={styles.heldFridayContentPopup}
      MessagesComponent={
        <div className={styles.whatChangeDatingPopupMessageContainer}>
          <div className={styles.textBold}>デート日：</div>
          {date}
          <div>枠が空いた場合に通知にてお知らせします！</div>
        </div>
      }
      messagesContainerClassName={styles.imageContentMsg}
      boldMsgIndex={[0]}
      imageUnderTitle={cancelWaitlistParticipation}
      textCenterMsg={true}
      messageClassName={classNames(styles.messageClassName, styles.centerMsg)}
      positiveButtonTitle={'設定する'}
      positiveButtonClassName={styles.positiveButtonClassName}
      onPositiveClicked={onPositiveClick}
      customCloseButton={
        <img
          src={closeWhiteMode}
          className={styles.closeButton}
          onClick={onClose}
          alt=""
        />
      }
    />
  );
};

export const renderHeriDatingPopup = (
  state,
  onPositiveClick,
  onCancelClick
) => {
  return (
    <Popup
      visible={state.showHeriDatingPopup}
      contentStyle={styles.heldFridayContentPopup}
      titleClassName={classNames(styles.titleClassName, styles.bigPopupTitle)}
      messagesContainerClassName={styles.imageContentMsg}
      imageUnderTitle={heriDatingContent}
      messageClassName={classNames(styles.messageClassName, styles.centerMsg)}
      positiveButtonTitle={'応募する'}
      positiveButtonClassName={classNames(
        styles.positiveButtonClassName,
        styles.heriPositiveButton
      )}
      onPositiveClicked={onPositiveClick}
      popupContent={styles.heriPopupContent}
      bodyStyle={styles.heriPopupBody}
      footerClassName={styles.heriPopupFooter}
      onCancelClicked={onCancelClick}
      imageContentStyle={styles.heriImageContent}
      buttonContainerStyle={styles.heriButtonContainer}
    />
  );
};

export const renderDailyDatingPopup = (state, onPositiveClick) => {
  return (
    <Popup
      visible={state.showDailyDatingPopup}
      TitleComponent={
        <div className={styles.dailyDatingPopupTitleContainer}>
          <div className={styles.subTitle}>
            <img
              alt="Daily dating title decor 1"
              src={dailyDatingPopupTitleDecor1}
              className={styles.decorImage1}
            ></img>
            <div className={styles.content}>\期間限定リリース/</div>
            <img
              alt="Daily dating title decor 2"
              src={dailyDatingPopupTitleDecor2}
              className={styles.decorImage2}
            ></img>
          </div>
          <div className={styles.title}>毎日デート開催</div>
        </div>
      }
      MessagesComponent={
        <div className={styles.dailyDatingPopupMessagesContainer}>
          <div className={styles.messages}>
            <div>さらに！</div>
            <div>平日はデート開始が19時からになります！</div>
          </div>
          <img
            alt="Daily dating message"
            src={dailyDatingPopupMessageImg}
            className={styles.messageImg}
          />
        </div>
      }
      positiveButtonTitle={'デートを予約する'}
      positiveButtonClassName={classNames(
        styles.positiveButtonClassName,
        styles.dailyDatingPositiveButton
      )}
      onPositiveClicked={onPositiveClick}
      popupContent={styles.dailyDatingPopupContent}
      bodyStyle={styles.dailyDatingPopupBody}
      FooterComponent={
        <div className={styles.dailyDatingFooterNote}>
          期間：2023.6.30(金)~2023.7.31(月)
        </div>
      }
      disableClose
    />
  );
};

export const renderEveryDayDatingPopup = (state, onPositiveClick) => {
  return (
    <Popup
      visible={state.showEveryDayDatingPopup}
      title={'平日デートが19時ごろに!!'}
      contentStyle={styles.heldFridayContentPopup}
      titleClassName={classNames(styles.titleClassName, styles.bigPopupTitle)}
      MessagesComponent={
        <div className={styles.everyDayDatingMessageContainer}>
          <img src={EveryDayDating} alt="" className={styles.image} />
          <div className={styles.text}>
            <div>
              <span className={styles.textBold}>
                「仕事終わりにデートしたい！」
              </span>
              という
            </div>
            <div>多くの会員様のご意見を元に</div>
            <div>デート開始時間を変更しました。</div>
          </div>
        </div>
      }
      positiveButtonTitle={'了解'}
      positiveButtonClassName={classNames(
        styles.positiveButtonClassName,
        styles.everyDayDatinPositiveButton
      )}
      onPositiveClicked={onPositiveClick}
      FooterComponent={
        <div className={styles.everyDayDatingFooterContainer}>
          \ 2023年06月30日から開催！/
        </div>
      }
      disableClose
    />
  );
};

export const renderBlackUserWelcomePopup = (state, onPositiveClick) => {
  return (
    <Popup
      visible={state.showBlackUserWelcomePopup}
      TitleComponent={
        <div className={styles.blackUserWelcomeTitleContainer}>
          <img
            src={blackUserWelcomePopupTitle}
            className={styles.blackUserWelcomePopupImg}
            alt=""
          />
          <div className={styles.blackUserWelcomeTitleText}>
            ブラックプランへようこそ
          </div>
        </div>
      }
      messages={[
        'ブラック審査に合格した上位3%の女性とマッチングされます。',
        'ぜひ、特別なデートをお楽しみください。'
      ]}
      messageClassName={styles.messageClassName}
      positiveButtonTitle={'閉じる'}
      positiveButtonClassName={styles.positiveButtonClassName}
      onPositiveClicked={onPositiveClick}
      disableClose
      bodyStyle="blackUserWelcomePopupBody"
    />
  );
};

export const BachelorMemberWelcomePopup = ({ visible, onPositiveClick }) => {
  return (
    <Popup
      visible={visible}
      customPopUpWidth={POP_UP_WIDTH}
      TitleComponent={
        <div className={styles.bachelorMemberWelcomeTitleContainer}>
          <img
            src={bachelorMember}
            className={styles.bachelorMemberWelcomeImg}
            alt=""
          />
          <div className={styles.bachelorMemberWelcomeTitleText}>
            入会審査に仮合格しました！
          </div>
        </div>
      }
      messages={['さっそく日程を選択して、デートに参加しましょう！']}
      messageClassName={styles.bachelorMemberWelcomeMessageClassName}
      positiveButtonTitle={'日程選択に進む'}
      positiveButtonClassName={styles.stylePositiveButton}
      onPositiveClicked={onPositiveClick}
      footerClassName={styles.footerClassName}
      customContentStyle={styles.customContentStyle}
      messagesContainerAddClass={styles.messagesContainerAddClass}
      popupContent={styles.popupContent}
      disableClose
      bodyStyle={styles.bodyStyle}
    />
  );
};

export const BachelorMemberShipCardPopup = ({
  visible,
  onPositiveClick,
  userGender,
  registrationVersion
}) => {
  const messageBachelorMemberShipCardPopup =
    isPreferenceConfirmRegistrationVersion(registrationVersion)
      ? ['おめでとうございます！\n今からAIがピッタリなお相手を探します。']
      : userGender === UserGender.FEMALE
      ? ['早速参加申請をしてデートに参加しましょう！']
      : ['早速お相手を確認してデートに参加しましょう！'];
  return (
    <Popup
      key="bachelor-member-ship-card-popup"
      visible={visible}
      TitleComponent={
        <div className={styles.bachelorMemberTitleContainer}>
          <img
            src={bachelorMember}
            className={styles.bachelorMemberImg}
            alt=""
          />
          <div className={styles.bachelorMemberTitleText}>
            {isPreferenceConfirmRegistrationVersion(registrationVersion)
              ? '入会審査に仮合格しました！'
              : userGender === UserGender.FEMALE
              ? '入会審査に仮合格しました！🎉'
              : '入会審査に合格しました！🎉'}
          </div>
        </div>
      }
      messages={messageBachelorMemberShipCardPopup}
      messageClassName={styles.messageClassName}
      positiveButtonTitle={
        isPreferenceConfirmRegistrationVersion(registrationVersion)
          ? 'お相手を探す'
          : '了解'
      }
      positiveButtonClassName={styles.positiveButtonClassName}
      onPositiveClicked={onPositiveClick}
      disableClose
      bodyStyle={'blackUserWelcomePopupBody'}
    />
  );
};

export const checkDateExisted = (date, participateTimeSlots) =>
  !!participateTimeSlots.filter(
    (item) =>
      item.id === date.id &&
      item.time_from === date.time_from &&
      item.time_to === date.time_to
  ).length;

export const renderSummerCampaignPopup = (
  state,
  onPositiveClicked,
  onNegativeClicked,
  onChangeCheckbox
) => {
  return (
    <DialogWithPhoto
      visible={state.showSummerCampaignPopup}
      titleText={`コミットキャンペーン開催中！`}
      titleImage={summerCampaignPopupBanner}
      titleImageClassName={styles.summerCampaignPopupBanner}
      customTitleClassName={styles.summerCampaignPopupTitle}
      messages={[
        '今年の夏は彼氏も豪華プレゼントもGET！',
        'バチェラーデートが彼氏作りを全力サポートします！'
      ]}
      positiveButtonTitle={'詳しく見る'}
      onPositiveClicked={onPositiveClicked}
      negativeButtonTitle={'閉じる'}
      onNegativeClicked={onNegativeClicked}
      FooterComponent={
        <div className={styles.summerCampaignPopupCheckbox}>
          <Checkbox
            label="今後表示しない"
            onChange={onChangeCheckbox}
            name="summerCampaignPopupCheckbox"
            checked={state.summerCampaignPopupCheckboxChecked}
          />
        </div>
      }
      contentClassName={styles.summerCampaignPopupContent}
      messagesContainerAddClass={styles.summerCampaignPopupMessagesContainer}
      positiveButtonClassName={classNames(
        styles.summerCampaignPopupButton,
        styles.summerCampaignPopupPositiveButton
      )}
      negativeButtonClassName={classNames(
        styles.summerCampaignPopupButton,
        styles.summerCampaignPopupNegativeButton
      )}
    />
  );
};
export const renderIkebukuroPopup = (
  state,
  onPositiveClicked,
  onNegativeClicked
) => {
  return (
    <DialogWithPhoto
      visible={state.showIkebukuroPopup}
      titleText={`池袋・目白エリアが解禁！`}
      titleImage={ikebukuroBanner}
      MessagesComponent={
        <div className={styles.whatChangeDatingPopupMessageContainer}>
          <div>「池袋・目白周辺でもデートしたい」という、</div>
          <div>
            多くの声を元に
            <span className={styles.textBold}>新しくエリアを追加</span>
            しました✨
          </div>
        </div>
      }
      titleImageClassName={styles.summerCampaignPopupBanner}
      customTitleClassName={styles.summerCampaignPopupTitle}
      messages={[
        '「池袋・目白周辺でもデートしたい」という、',
        '多くの声を元に新しくエリアを追加しました✨'
      ]}
      positiveButtonTitle={'希望エリアに追加する'}
      onPositiveClicked={onPositiveClicked}
      negativeButtonTitle={'閉じる'}
      onNegativeClicked={onNegativeClicked}
      contentClassName={styles.summerCampaignPopupContent}
      messagesContainerAddClass={styles.summerCampaignPopupMessagesContainer}
      positiveButtonClassName={classNames(
        styles.summerCampaignPopupButton,
        styles.summerCampaignPopupPositiveButton
      )}
      negativeButtonClassName={classNames(
        styles.summerCampaignPopupButton,
        styles.summerCampaignPopupNegativeButton
      )}
    />
  );
};

export const renderYokohamaPopup = (
  state,
  onPositiveClicked,
  onNegativeClicked
) => {
  return (
    <DialogWithPhoto
      visible={state.showYokohamaPopup}
      titleText={`横浜エリアが解禁✨`}
      titleImage={yokohamaBanner}
      MessagesComponent={
        <div className={styles.whatChangeDatingPopupMessageContainer}>
          <div>「横浜でデートを開催してほしい！」という、</div>
          <div>
            多くの声を元に
            <span className={styles.textBold}>新しくエリアを追加</span>
            しました🌹
          </div>
        </div>
      }
      titleImageClassName={styles.summerCampaignPopupBanner}
      customTitleClassName={styles.summerCampaignPopupTitle}
      positiveButtonTitle={'エリア変更に進む'}
      onPositiveClicked={onPositiveClicked}
      negativeButtonTitle={'閉じる'}
      onNegativeClicked={onNegativeClicked}
      contentClassName={styles.summerCampaignPopupContent}
      messagesContainerAddClass={styles.summerCampaignPopupMessagesContainer}
      positiveButtonClassName={classNames(
        styles.summerCampaignPopupButton,
        styles.summerCampaignPopupPositiveButton
      )}
      negativeButtonClassName={classNames(
        styles.summerCampaignPopupButton,
        styles.summerCampaignPopupNegativeButton
      )}
    />
  );
};

export const renderCancelParticipationItemBetaPopup = (
  state,
  onPositiveClick,
  onNegativeClicked
) => {
  return (
    <Popup
      visible={state.showCancelParticipationItemBetaPopup}
      title="デートをキャンセルしますか？"
      messages={[
        'デートをキャンセルするとデートのセッティングがされなくなります'
      ]}
      messageClassName={styles.messageClassName}
      positiveButtonTitle="キャンセルする"
      negativeButtonTitle="戻る"
      onPositiveClicked={onPositiveClick}
      onNegativeClicked={onNegativeClicked}
      disableClose
    />
  );
};

export const renderCancelParticipationItemBetaSuccessPopup = (
  state,
  onPositiveClick
) => {
  return (
    <Popup
      visible={state.showCancelParticipationItemBetaSuccessPopup}
      title="予約がキャンセルされました"
      messages={['新しいデートを予約しましょう！']}
      messageClassName={styles.messageClassName}
      positiveButtonTitle="了解"
      onPositiveClicked={onPositiveClick}
      disableClose
    />
  );
};

export const POP_UP_WIDTH = '342px';

export const WEEK_ORDER_KEY = {
  FIRST_WEEK: 'firstWeek',
  SECOND_WEEK: 'secondWeek',
  THIRD_WEEK: 'thirdWeek',
  ALL_WEEKS: 'allWeeks'
};

export const truncateText = (text) => {
  if (!text) {
    return '';
  }

  const normalized = text.replace(/[\s\u3000]/g, '');

  if (normalized.length > 3) {
    return normalized.slice(0, 3) + '...';
  }

  return normalized;
};

export const renderTermsOfUsePopup = (
  state,
  onPositiveClick,
  onNegativeClicked
) => {
  const MessagesComponent = () => {
    return (
      <>
        <div className={styles.styleTextContent}>
          <a
            href={NEW_TERM_OF_SERVICE_LINK}
            target="_blank"
            className={styles.linkText}
            rel="noreferrer"
          >
            利用規約/プライバシーポリシー
          </a>
          が変更になりました。
        </div>
        <div className={styles.styleTextContent}>
          変更内容を確認の上、ご同意ください。
        </div>
      </>
    );
  };
  return (
    <Popup
      visible={state.showTermsOfUsePopup}
      bodyStyle={styles.wrapperTermsOfUsePopup}
      title="バチェラーデート 利用規約"
      titleClassName={styles.titleTermsOfUseClassName}
      MessagesComponent={<MessagesComponent />}
      customContentStyle={styles.contentTermsOfUseStyle}
      positiveButtonTitle="利用規約に同意する"
      onPositiveClicked={onPositiveClick}
      positiveButtonClassName={styles.positiveTermsOfUseClass}
      negativeButtonTitle="同意しない"
      negativeButtonClassName={styles.negativeTermsOfUseClass}
      onNegativeClicked={onNegativeClicked}
      buttonContainerStyle={styles.termsOfUseButtonContainer}
      disableClose
    />
  );
};

export const renderConsentRequiredPopup = (state, onPositiveClick) => {
  return (
    <Popup
      visible={state.showConsentRequiredPopup}
      bodyStyle={styles.wrapperTermsOfUsePopup}
      title="利用するには同意が必要です"
      titleClassName={styles.titleConsentRequiredClassName}
      MessagesComponent={<></>}
      customContentStyle={styles.contentTermsOfUseStyle}
      positiveButtonTitle="戻る"
      onPositiveClicked={onPositiveClick}
      positiveButtonClassName={styles.positiveTermsOfUseClass}
      buttonContainerStyle={styles.termsOfUseButtonContainer}
      disableClose
    />
  );
};

export const CancelOneParticipatePopup = ({
  visible,
  onPositiveClick,
  onNegativeClicked
}) => {
  return (
    <Popup
      visible={visible}
      title="デートをキャンセルしますか"
      messages={[
        '予約のキャンセルをするとデートのセッティングがされなくなります。'
      ]}
      messageClassName={styles.messageClassName}
      positiveButtonTitle="はい"
      negativeButtonTitle="戻る"
      onPositiveClicked={onPositiveClick}
      onNegativeClicked={onNegativeClicked}
      onCancelClicked={onNegativeClicked}
    />
  );
};

export const SuccessCancelOneParticipatePopup = ({
  visible,
  onPositiveClick,
  isFromMatchProfile
}) => {
  return (
    <Popup
      visible={visible}
      title="予約キャンセルが完了しました"
      messages={['新しいデート日を予約しましょう！']}
      messageClassName={styles.messageClassName}
      positiveButtonTitle={isFromMatchProfile ? 'デート予約に進む' : '了解'}
      onPositiveClicked={onPositiveClick}
      onCancelClicked={onPositiveClick}
      disableClose={isFromMatchProfile}
      bodyStyle={isFromMatchProfile ? styles.bodyCancelDateStyle : undefined}
      positiveButtonClassName={
        isFromMatchProfile ? styles.positiveButtonClassName : undefined
      }
      messagesContainerAddClass={
        isFromMatchProfile ? styles.messagesContainerAddClass : undefined
      }
      titleClassName={
        isFromMatchProfile ? styles.titleClassNameCancelDate : undefined
      }
    />
  );
};

export function getLastClassName(className) {
  if (!className || typeof className !== 'string') return null;
  const match = className.match(/(\S+)$/);
  return match ? match[1] : null;
}

// 追加の定数
export const POPUP_TYPES = {
  RESUMPTION_COMPLETE_POPUP: 1
};

export const DEFAULT_TIMER_INTERVALS = {
  MB_TIMER: 2500,
  FOOTER_UPDATE: 0,
  TIME_CYCLE: 3000
};

export const DEFAULT_ARRAY_SIZE = {
  CHECK_DATE_ARRAY: 9
};

// 状態管理用のユーティリティ関数
export const createInitialState = (props, locationState) => {
  const {
    temporaryDateSelectedByUser,
    participatingTimeSlots,
    thisWeekSelected,
    nextWeekSelected,
    nextNextWeekSelected,
    weeks,
    thisWeekDates,
    nextWeekDates,
    nextNextWeekDates,
    fromResumption
  } = locationState || {};

  const isCheckBackFromDating = !!(
    participatingTimeSlots && participatingTimeSlots.length > 0
  );

  return {
    // 基本情報
    isCheckBackFromDating,
    participatingTimeSlots: participatingTimeSlots || [],
    selectedSlotPrefecture: {},
    currentDateDataSelected: '',

    // ポップアップ状態
    whatTimePopupVisible: false,
    whatChangeDatingPopup: false,
    waitlistNotificationPopup: false,
    configurationCompletePopup: false,
    cancelWaitlistPopup: false,
    confirmationPopupVisible: false,
    cancelReservationPopupVisible: false,
    reservationCancelledConfirmationVisible: false,
    showValidationPopup: false,
    confirmCancelDatePopup: false,
    reservedDateInfoPopup: false,
    messageValidation: '',
    unselectParticipatedTimeSlots: [],

    // 基本データ
    dateTobeCancelled: null,
    temporaryDateSelectedByUser: temporaryDateSelectedByUser || false,
    fromResumption: fromResumption || false,

    // チケット・クーポン関連ポップアップ
    confirmUseTicketPopupVisible: false,
    trialAwaitingForApprovalPopupVisible: false,
    matchingPopupVisible: false,
    paidUserNoDatingCouponPopupVisible: false,
    reservationCancellationPopupVisible: false,
    confirmDatingPopupVisible: false,
    dateStartTimePopupVisible: false,
    awaitingApprovalPopupVisible: false,
    approvedTrialPaidPopupVisible: false,
    useCouponPopupVisible: false,
    useCouponWarningPopupVisible: false,
    refundCommitOptionPopupVisible: false,
    closedDatePopupVisible: false,
    missingFeedbackPopup: false,
    awaitingCancelledDatePopupVisible: false,
    confirmCouponPopupVisible: false,

    // 週選択状態
    thisWeekSelected: thisWeekSelected || false,
    nextWeekSelected: nextWeekSelected || false,
    nextNextWeekSelected: nextNextWeekSelected || false,
    nextWeekSelectedAwaitingCancel: false,
    nextNextWeekSelectedAwaitingCancel: false,
    showNextNextWeekBtn: true,

    // 週データ
    weeks: weeks || [],
    isShowThisWeek: false,
    isShowNextWeek: false,
    isShowNextNextWeek: false,
    thisWeekDates: thisWeekDates || [],
    nextWeekDates: nextWeekDates || [],
    nextNextWeekDates: nextNextWeekDates || [],

    // 特殊ポップアップ
    showParticipationTwoDatingPopup: false,
    unpaid_payment_popup: false,
    payment_processing_popup: false,
    showResumptionPopup: false,
    showResumptionCompletePopup: false,
    showResumptionSucceedDatePopup: false,
    showResumptionNoSucceedDatePopup: false,
    invalidCancelChangePopup: false,

    // ユーザー情報
    participationAvailability: '',
    couponCount: 0,
    userStatus: props.userStatus || 4, // UserStatus.APPROVED_BY_SYSTEM
    hasDateSuccess: props.hasDateSuccess || false,
    hasOpenInvoice: props.hasOpenInvoice || false,
    lastInvoiceUrlUnpaid: props.lastInvoiceUrlUnpaid || '',
    arrCheckDate: Array(DEFAULT_ARRAY_SIZE.CHECK_DATE_ARRAY).fill(true),
    disableRequestButtonCancelDate: false,
    mrb: false,
    timeCycle: DEFAULT_TIMER_INTERVALS.TIME_CYCLE,
    registrationComplete: props.registrationComplete || false,
    userGender: props.userGender,
    succeededDayCount: 0,
    hasUnpaidInvoice: false,
    invoiceUrlUnpaid: '',
    messageValidateRegistrationStep: '',
    currentStepUser: 0,
    showValidateRegistrationPopup: false,
    currentServerTime: props.currentServerTime,
    participatedTimeSlots: [],
    preParticipatedTimeSlots: [],
    isPreActionUnselectParticipatedDay: false,
    shownCouponNeedPopupWeeks: [],
    showCompleteValueOptionPopup: false,
    hasDateCanSelect: false,
    isWhiteMode: false,
    validateSelectDateFailPopup: false,
    paymentNotCompletedPopup: false,
    validateSelectDateFailContent: [],

    // その他のポップアップ
    showHeldFridayDatingPopup: false,
    showHeriDatingPopup: false,
    showYokohamaPopup: false,
    firstLoginAfterApproved: false,
    showDailyDatingPopup: false,
    showEveryDayDatingPopup: false,
    showBlackUserWelcomePopup: false,
    bachelorMemberShipCardPopup: false,
    bachelorMemberWelcomePopup: false,
    showCancelParticipationItemBetaPopup: false,
    showCancelParticipationItemBetaSuccessPopup: false,
    cancelParticipationItemBetaDate: null,
    noticePopups: [],
    showAgeVerificationRequiredPopup: false,

    // トライアル情報
    trialEnd: '',
    userPlan: '',
    monthlyFee: 0,
    datingDate: '',
    costPlanPerADatingFee: 0,
    firstTimeEnterTheAppAfterApprovedForMale: false,
    firstTimeEnterTheAppAfterApprovedForFemale: false,
    summerCampaignPopupCheckboxChecked: false,

    // その他
    isChargeWhenCancelSampleDate: false,
    bubble_banner: '',
    validateSelectingErrors: {},

    // モーダル関連
    isShowConfirmCafeAreaModal: false,
    isShowSelectCafeAreaModal: false,
    isCloseBottomSheet: false,
    dateSelected: {},
    userPreferredArea: {},
    allUserPreferredAreas: [],
    isCheckDateSelected: false,
    isReloadNotices: true,
    isShowAreaBottomSheet: false,
    isCloseAreaBottomSheet: false,
    selectedPrefecture: null,
    pendingPrefectureChange: null,
    pendingBottomSheet: false,
    prefectureAreas: [],
    prefectureMasterData: [],

    // エリア変更関連ポップアップ
    showErrorRequestPopup: false,
    conditionChangePrefecture: '',

    // フィードバック関連
    hasPendingFeedback: false,
    needFeedbacks: [],

    // GA イベント
    callGAEvent: {
      [WEEK_ORDER_KEY.FIRST_WEEK]: false,
      [WEEK_ORDER_KEY.SECOND_WEEK]: false,
      [WEEK_ORDER_KEY.THIRD_WEEK]: false
    }
  };
};

// ポップアップを閉じる
export const createClosePopupState = () => ({
  whatTimePopupVisible: false,
  whatChangeDatingPopup: false,
  confirmationPopupVisible: false,
  confirmUseTicketPopupVisible: false,
  reservationCancellationPopupVisible: false,
  confirmDatingPopupVisible: false,
  cancelReservationPopupVisible: false,
  dateStartTimePopupVisible: false,
  awaitingApprovalPopupVisible: false,
  approvedTrialPaidPopupVisible: false,
  useCouponPopupVisible: false,
  trialAwaitingForApprovalPopupVisible: false,
  matchingPopupVisible: false,
  showValidateRegistrationPopup: false,
  paidUserNoDatingCouponPopupVisible: false,
  useCouponWarningPopupVisible: false,
  closedDatePopupVisible: false,
  awaitingCancelledDatePopupVisible: false,
  showCompleteValueOptionPopup: false,
  confirmCouponPopupVisible: false,
  reservationCancelledConfirmationVisible: false,
  showValidationPopup: false,
  unpaid_payment_popup: false,
  payment_processing_popup: false,
  showResumptionSucceedDatePopup: false,
  showResumptionNoSucceedDatePopup: false,
  showResumptionCompletePopup: false,
  showResumptionPopup: false,
  missingFeedbackPopup: false,
  confirmCancelDatePopup: false,
  invalidCancelChangePopup: false,
  showParticipationTwoDatingPopup: false,
  showHeldFridayDatingPopup: false,
  showCancelParticipationItemBetaPopup: false,
  showCancelParticipationItemBetaSuccessPopup: false,
  showAgeVerificationRequiredPopup: false,
  firstTimeEnterTheAppAfterApprovedForMale: false,
  firstTimeEnterTheAppAfterApprovedForFemale: false,
  showSummerCampaignPopup: false,
  showYokohamaPopup: false,
  paymentNotCompletedPopup: false,
  waitlistNotificationPopup: false,
  configurationCompletePopup: false,
  cancelWaitlistPopup: false,
  showErrorRequestPopup: false
});

export const setupHistoryListener = (
  props,
  shouldKeepSessionStorage,
  clearSelectionOnNonDatingConfirmationNavigation
) => {
  window.history.replaceState({}, document.title);

  // History listenerを追加して画面遷移時にSessionStorageをクリア
  return props.history.listen((location, action) => {
    // participation画面から他の画面への遷移時のみチェック
    if (action === 'PUSH' || action === 'REPLACE') {
      const targetPath = location.pathname;
      if (!shouldKeepSessionStorage(targetPath)) {
        clearSelectionOnNonDatingConfirmationNavigation(targetPath);
      }
    }
  });
};

export const extractLocationStateInfo = (props) => {
  const hasUnpaidInvoice = path(
    ['history', 'location', 'state', 'hasUnpaidInvoice'],
    props
  );

  const invoiceUrlUnpaid = path(
    ['history', 'location', 'state', 'invoiceUrlUnpaid'],
    props
  );

  const isFrom2ndStepSeven = path(
    ['location', 'state', 'isFrom2ndStepSeven'],
    props
  );

  return {
    hasUnpaidInvoice,
    invoiceUrlUnpaid,
    showCompleteValueOptionPopup: isFrom2ndStepSeven
  };
};

export const shouldShowRefundCommitPopup = (props, isRefund) => {
  return (
    isRefund &&
    props.userGender === 2 && // UserGender.FEMALE
    props.commitOption &&
    props.numberOfCompletedDate >= 5 &&
    !props.issetCommitOptionFeedbackForm
  );
};

// 複雑な条件分岐を簡素化するヘルパー関数群
export const hasValidPrefectureArea = (prefectureData) => {
  return (
    prefectureData && prefectureData.area && prefectureData.area.length > 0
  );
};

export const hasValidAPIResponse = (response) => {
  return response && response.status === 200 && response.data;
};

export const hasValidAPIResponseSuccess = (response) => {
  return (
    response &&
    response.status === 'success' &&
    response.data &&
    response.data.data &&
    response.data.data.formData
  );
};

export const extractPrefectureData = (apiData) => {
  if (apiData && apiData.data && apiData.data.prefectureData) {
    const prefectureData = apiData.data.prefectureData;
    return Array.isArray(prefectureData) ? prefectureData : [];
  }
  return [];
};

export const findPrefectureById = (formData, prefectureId) => {
  const prefData = formData.find((p) => p.id === prefectureId);
  return hasValidPrefectureArea(prefData) ? prefData.area : [];
};

export const getFirstAreaFromPrefecture = (prefectureData) => {
  if (hasValidPrefectureArea(prefectureData)) {
    const firstArea = prefectureData.area[0];
    return {
      area_id: firstArea.id,
      area_name: firstArea.name
    };
  }
  return null;
};
